import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureUtmParamsFromUrl } from '@/lib/utm-params';

/**
 * Component that captures UTM parameters from the URL on route changes
 * and saves them to localStorage for later use (e.g., during registration)
 */
const UtmCapture = () => {
  const location = useLocation();

  useEffect(() => {
    // Capture UTM params whenever the route changes
    captureUtmParamsFromUrl();
  }, [location.search]); // Only re-run when search params change

  // This component doesn't render anything
  return null;
};

export default UtmCapture;

